export default __webpack_public_path__ + "static/media/appoinment.fbeab17d.png";